<template>
  <section class="section chatGroupDetail" :class="{open: show}"
    v-on:click="sectionClicked">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="tree"></div>
      <div class="rightContentIn">
        <div class="header">
          <div class="backBtn" v-on:click="close"></div>
          <h4 v-if="group">{{group.name}}</h4>
          <button class="createGroup" v-on:click="groupInfo">Group Info</button>
        </div>
        <div class="contentSc">
          <div>
            <div class="stickyCnt">
              <div class="stickyChat" v-if="stickyChat">
                <h4>Pinned by {{stickyChat.name}}</h4>
                <p>{{stickyChat.message}}</p>
                <div class="unpin" v-on:click="unpin"></div>
              </div>
            </div>
            <perfect-scrollbar class="theChat" ref="wrapper"
              v-on:scroll="scrolled">
              <div class="loadingChat" v-if="loading"></div>
              <div class="chatWrapper" v-else>
                <div class="msgItem" v-for="(m, i) in chats" :key="i"
                  :class="{me: m.me, info: !m.name, hideName: m.hideName}">
                  <div class="avatar" :class="{noImg: !m.avatar, finisher: m.isFinisher}"
                    v-if="!m.hideName && m.name"
                    :style="{'background-image': `url(${m.avatar})`}">
                    <span>{{m.name.substr(0, 2)}}</span>
                  </div>
                  <div class="msgContent" :class="{deleted: m.deleted}"
                    v-if="!m.hideName || m.message"
                    v-on:click.stop="msgMoreId = m.id">
                    <h5 v-if="!m.hideName">{{m.name}}</h5>
                    <div class="reply" v-if="m.reply">
                      <h5>{{m.reply.name}}</h5>
                      <p>{{m.reply.message}}</p>
                    </div>
                    <span class="message" v-if="m.message">{{m.message}}</span>
                    <timeago :datetime="m.timestamp * 1000" v-if="!m.hideName"></timeago>
                    <div class="msgMore" v-if="m.message && m.name && m.id && m.deleted === 0
                      && msgMoreId === m.id">
                      <li v-on:click.stop="pinChat(m)">Pin pesan</li>
                      <li v-on:click.stop="replyTo = m; msgMoreId = null">Balas</li>
                      <li class="divider" v-if="m.userId === userId"></li>
                      <li class="red" v-on:click="deleteChat(i, m)"
                        v-if="m.userId === userId">Hapus pesan</li>
                    </div>
                  </div>
                  <div class="sticker" v-if="m.sticker"
                    :class="m.sticker"></div>
                  <div class="attLabel" v-if="m.profile">
                    Lihat profile saya</div>
                  <img class="profile" :src="m.profile"
                    v-if="m.profile">
                  <div class="attLabel" v-if="m.finisher">
                    Saya sudah menjadi FINISHER lho...</div>
                  <img class="profile" :src="m.finisher"
                    v-if="m.finisher">
                  <div class="uploading" v-if="m.uploading"></div>
                  <img class="imgPreview" v-else-if="m.imgPreview"
                    :src="m.imgPreview">
                </div>
              </div>
              <input ref="scHelper" class="scHelper">
            </perfect-scrollbar>
            <div class="chatFooter">
              <div class="scrollChat" v-if="chatScrolled"
                v-on:click="scrollWrapper"></div>
              <div class="textField"
                contenteditable placeholder="Write your message..."
                v-on:keydown="keyDown" ref="field"
                v-on:focus="emojiOpen = false"></div>
              <div class="imgPreview" v-if="imgPreview"
                v-on:click="imgPreview = null"
                :style="{'background-image': `url(${imgPreview})`}"></div>
              <div class="replyCnt" v-if="replyTo">
                <label>Balas ke</label>
                <p>{{replyTo.message}}</p>
                <div class="close" v-on:click="replyTo = null"></div>
              </div>
              <div class="emojiCnt" v-if="emojiOpen"
                v-on:click.stop="doNothing">
                <VEmojiPicker @select="selectEmoji" />
              </div>
              <div class="stickerCnt" v-if="showSticker">
                <div class="stickerItem lili-hi"
                  v-on:click.stop="sendSticker('lili-hi')"></div>
                <div class="stickerItem menolak"
                  v-on:click.stop="sendSticker('menolak')"></div>
                <div class="stickerItem nunu-mantul"
                  v-on:click.stop="sendSticker('nunu-mantul')"></div>
                <div class="stickerItem nunu-hmmm"
                  v-on:click.stop="sendSticker('nunu-hmmm')"></div>
                <div class="stickerItem lari"
                  v-on:click.stop="sendSticker('lari')"></div>
                <div class="stickerItem sombong"
                  v-on:click.stop="sendSticker('sombong')"></div>
              </div>
              <div class="attCnt" v-if="openAtt">
                <li class="media" v-on:click="$refs.file.click();">
                  Photo<p>Share picture to the group</p></li>
                <li class="profile" v-on:click="sendProfile">
                  Profile<p>Share your current profile</p></li>
                <li class="finisher" v-on:click="sendFinisher"
                  v-if="1>2">
                  Finisher<p>hanya finisher yang bisa membagikan
                  profil finisher</p></li>
              </div>
              <div class="sendBtn sticker" v-on:click.stop="emojiOpen = false;
                openAtt = false; showSticker = !showSticker;" v-if="1>2"></div>
              <div class="sendBtn emoji" v-on:click.stop="emojiOpen = !emojiOpen;
                openAtt = false; showSticker = false;"></div>
              <div class="sendBtn attachmentIcon"
                v-on:click.stop="openAtt = !openAtt; emojiOpen = false;
                showSticker = false;"></div>
              <div class="sendBtn" v-on:click="sendMessage"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input type="file" ref="file"
      accept="image/png,image/x-png,image/jpeg,image/jpg,image/gif"
      v-on:change="handleFile"
      style="display: none">
    <Confirmation ref="confirmDialog"/>
    <GroupInfo ref="groupInfo"/>
  </section>
</template>

<script>
import { VEmojiPicker } from 'v-emoji-picker';
import Confirmation from '@/components/Confirmation.vue';
import GroupInfo from '@/components/GroupInfo.vue';

export default {
  name: 'chatGroupDetail',
  components: { Confirmation, VEmojiPicker, GroupInfo },
  data() {
    return {
      next: null,
      point: 0,
      show: false,
      chats: [],
      loading: true,
      emojiOpen: false,
      openAtt: false,
      showSticker: false,
      messages: [],
      chatScrolled: false,
      stickyChat: null,
      group: null,
      attachment: null,
      imgPreview: null,
      msgMoreId: null,
      replyTo: null,
      userId: null,
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      this.emojiOpen = false;
      this.openAtt = false;
      this.showSticker = false;
      this.msgMoreId = null;
    },
    open(d, n) {
      this.next = n;
      this.group = d;
      this.show = true;
      this.replyTo = null;
      this.attachment = null;
      this.imgPreview = null;
      this.getData();
      this.stickyChat = null;
      this.getPinned();
    },
    close(b, v) {
      this.show = false;
      if (this.next) this.next(b, v);
    },
    getPinned() {
      this.$http.get(this.$config.uri(`group/${this.group.id}/pinned`)).then((r) => {
        this.stickyChat = (r.data.status === 200) ? r.data.data : null;
      });
    },
    groupInfo() {
      this.$refs.groupInfo.open(this.group, (b, v) => {
        if (!b) return;
        if (v && v.type === 'leave') {
          this.close(b, v);
        }
      });
    },
    getData() {
      if (!this.group) return;
      this.loading = true;
      this.$http.get(this.$config.uri(`group/${this.group.id}/chat`)).then((r) => {
        this.loading = false;
        this.chats = (r.data.status === 200) ? r.data.data : [];
        setTimeout(() => {
          this.scrollWrapper();
        });
      });
    },

    /**
     * Chat
     *
     */
    scrolled(e) {
      this.chatScrolled = (e.srcElement.scrollTop + e.srcElement.clientHeight + 100
        < e.srcElement.scrollHeight);
    },
    selectEmoji(emoji) {
      this.$refs.field.innerHTML = `${this.$refs.field.innerHTML.trim()} ${emoji.data}`;
    },
    scrollWrapper() {
      this.chatScrolled = false;
      setTimeout(() => {
        if (!this.$refs.wrapper) return;
        this.$refs.wrapper.$el.scrollTo(0, this.$refs.wrapper.$el.scrollHeight);
      });
    },
    unpin() {
      if (!this.stickyChat) return;
      this.$refs.confirmDialog.open({
        title: 'Unpin Pesan',
        desc: 'Apakah kamu yakin ingin mengahpus pesan ini dari daftar yang di sematkan?',
        action: 'Unpin Pesan',
      }, (b) => {
        if (!b) return;
        this.$http.get(this.$config.uri(`group/chat/${this.stickyChat.id}/unpin`));
        this.stickyChat = null;
        this.getPinned();
      });
    },
    pinChat(item) {
      this.msgMoreId = null;
      this.$refs.confirmDialog.open({
        title: 'Pin Pesan',
        desc: 'Apakah kamu yakin ingin pin pesan ini? Pin lama jika ada akan tergantikan',
        action: 'Pin Pesan',
      }, (b) => {
        if (!b) return;
        this.stickyChat = item;
        this.$http.get(this.$config.uri(`group/chat/${item.id}/pin`));
      });
    },
    deleteChat(i, item) {
      this.msgMoreId = null;
      this.$refs.confirmDialog.open({
        title: 'Hapus Pesan',
        desc: 'Apakah kamu yakin ingin mengahpus pesan ini?',
        action: 'Hapus Pesan',
      }, (b) => {
        if (!b) return;
        this.chats[i].deleted = 1;
        this.chats[i].message = 'Pesan dihapus';
        this.$http.get(this.$config.uri(`group/chat/${item.id}/delete`));
      });
    },
    sendSticker(st) {
      this.showSticker = false;
      const msgData = {
        groupId: this.group.id,
        sticker: st,
        name: this.$session.get('tufi2_name'),
        avatar: this.$session.get('tufi2_avatar'),
        me: true,
        timestamp: Math.floor(Date.now() / 1000),
        isFinisher: (this.point >= 1640),
      };
      this.chats.unshift(msgData);
      this.scrollWrapper();
      this.$http.post(this.$config.uri('group/chat/send'), msgData).then((r2) => {
        msgData.id = r2.data.id;
        this.$socket.emit('chat', {
          key: this.$config.apiKey,
          token: this.$session.get('tufi2_jwt'),
          id: msgData.id,
        });
      });
    },
    sendProfile() {
      const msgData = {
        groupId: this.group.id,
        profile: null,
        name: this.$session.get('tufi2_name'),
        avatar: this.$session.get('tufi2_avatar'),
        me: true,
        timestamp: Math.floor(Date.now() / 1000),
        isFinisher: (this.point >= 1640),
        uploading: true,
      };
      this.chats.unshift(msgData);
      this.scrollWrapper();
      this.$http.get(this.$config.uri('user/share/create')).then((r) => {
        msgData.uploading = false;
        if (r.data.status !== 200) return;
        msgData.profile = r.data.uri;
        setTimeout(() => {
          this.scrollWrapper();
        }, 500);
        msgData.profileUuid = r.data.uuid;
        this.$http.post(this.$config.uri('group/chat/send'), msgData).then((r2) => {
          msgData.id = r2.data.id;
          this.$socket.emit('chat', {
            key: this.$config.apiKey,
            token: this.$session.get('tufi2_jwt'),
            id: msgData.id,
          });
        });
      });
    },
    sendFinisher() {
      if (this.point < 1640) {
        this.$refs.confirmDialog.open({
          title: 'Kamu Bukan Finisher',
          desc: 'Hanya FINISHER yang bisa membagikan badge Finisher',
          confirm: false,
          action: 'Tutup',
        });
        return;
      }
      const msgData = {
        groupId: this.group.id,
        finisher: null,
        name: this.$session.get('tufi2_name'),
        avatar: this.$session.get('tufi2_avatar'),
        me: true,
        timestamp: Math.floor(Date.now() / 1000),
        uploading: true,
        isFinisher: (this.point >= 1640),
      };
      this.chats.unshift(msgData);
      this.scrollWrapper();
      this.$http.get(this.$config.uri('user/finisher/create')).then((r) => {
        msgData.uploading = false;
        if (r.data.status !== 200) return;
        msgData.finisher = r.data.uri;
        setTimeout(() => {
          this.scrollWrapper();
        }, 500);
        msgData.finisherUuid = r.data.uuid;
        this.$http.post(this.$config.uri('group/chat/send'), msgData).then((r2) => {
          msgData.id = r2.data.id;
          this.$socket.emit('chat', {
            key: this.$config.apiKey,
            token: this.$session.get('tufi2_jwt'),
            id: msgData.id,
          });
        });
      });
    },
    sendMessage() {
      this.emojiOpen = false;
      const msg = this.$refs.field.innerHTML
        .replace(/<br\s*[/]?>/gi, '\n')
        .replace(/(<([^>]+)>)/gi, '')
        .replace(/(&([^;]+);)/gi, '')
        .trim();
      this.$refs.field.innerHTML = '';
      if ((!msg || msg === '') && !this.attachment) return;
      const msgData = {
        groupId: this.group.id,
        message: msg,
        name: this.$session.get('tufi2_name'),
        avatar: this.$session.get('tufi2_avatar'),
        me: true,
        timestamp: Math.floor(Date.now() / 1000),
        isFinisher: (this.point >= 1640),
      };
      if (this.replyTo) msgData.reply = this.replyTo;
      this.replyTo = null;
      if (this.imgPreview) {
        msgData.uploading = true;
        this.imgPreview = null;
        this.chats.unshift(msgData);
        this.scrollWrapper();
        const formData = new FormData();
        formData.append('file', this.attachment);
        this.$http.post(this.$config.uri('group/chat/attachment'), formData).then((r) => {
          this.attachment = null;
          msgData.uploading = false;
          if (r.data.status !== 200) return;
          msgData.imgPreview = r.data.data.imgPreview;
          setTimeout(() => {
            this.scrollWrapper();
          }, 500);
          msgData.attId = r.data.data.id;
          this.$http.post(this.$config.uri('group/chat/send'), msgData).then((r2) => {
            msgData.id = r2.data.id;
            this.$socket.emit('chat', {
              key: this.$config.apiKey,
              token: this.$session.get('tufi2_jwt'),
              id: msgData.id,
            });
          });
        });
        return;
      }
      this.chats.unshift(msgData);
      this.scrollWrapper();
      this.$http.post(this.$config.uri('group/chat/send'), msgData).then((r2) => {
        msgData.id = r2.data.id;
        this.$socket.emit('chat', {
          key: this.$config.apiKey,
          token: this.$session.get('tufi2_jwt'),
          id: msgData.id,
        });
      });
    },
    keyDown(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        this.sendMessage();
        e.preventDefault();
      }
    },
    handleFile() {
      this.gotFile(this.$refs.file.files[0]);
    },
    gotFile(file) {
      if (file.type.split('/')[0] !== 'image') {
        this.$refs.confirmDialog.open({
          title: 'File Tidak Didukung',
          desc: 'Hanya file foto yang di dukung',
          confirm: false,
          action: 'Tutup',
        });
        return;
      }
      this.attachment = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.imgPreview = reader.result;
      };
      reader.readAsDataURL(file);
    },
  },
  mounted() {
    this.userId = this.$session.get('tufi2_id');
    this.point = this.$session.get('tufi2_point');
    this.sockets.unsubscribe('broadcast');
    this.sockets.subscribe('broadcast', (data) => {
      this.chats.unshift(data);
      const tls = (data.finisher || data.profile || data.imgPreview) ? 500 : 0;
      setTimeout(() => {
        this.scrollWrapper();
      }, tls);
    });
    setTimeout(() => {
      this.$refs.field.addEventListener('paste', (e) => {
        e.preventDefault();
        const { items } = (e.originalEvent || e).clipboardData;
        const file = (e.originalEvent || e).clipboardData.files[0];
        if (file) {
          this.gotFile(file);
          return;
        }
        const text = (e.originalEvent || e).clipboardData.getData('text/plain');
        window.document.execCommand('insertText', false, text);
      }, false);
    });
  },
};
</script>

<style scoped lang="scss">
.section.chatGroupDetail{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    right: 0; top: 0; bottom: 0;

    background-color: #fff;
    // background-color: #e6e1c1;
    // background-color: #b7e4c9;
    // background-image: linear-gradient(#fff 0, #e2fcec 50%, #fff);

    padding: 0 0 40px;
    box-sizing: border-box;
    width: 480px;
    z-index: 3;
    right: -480px;
    transition: all .38s ease;
    @media (max-width: 680px) {
      width: 96%; right: -96%;
    }
    .tree{
      position: absolute;
      left: 0; right: -10px; bottom: 0; top: 0;
      // background-image: url(../assets/high-five.png);
      background-size: auto 160px;
      background-position: 95% 85%;
      background-repeat: no-repeat;
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    // background-color: #000;
    background-color: rgba(0,0,0,.36);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      right: 0;
    }
  }
  .header{
    position: relative;
    padding: 0 20px;
    height: 60px;
    display: flex;
    align-items: center;
    z-index: 7;
    box-shadow: 0 0 4px rgba(0, 0, 0, .2);
    backdrop-filter: blur(20px);
    .backBtn{
      width: 40px; height: 40px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-next-black.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    .createGroup{
      border: none;
      border-radius: 50px;
      padding: 8px 16px;
      color: #fff;
      font-weight: 500;
      font-size: 16px;
      cursor: pointer;
      transition: all .3s ease;
      background-color: #5351a4;
      &:hover{
        background-color: #615fb1;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
      }
    }
    h4{
      font-size: 18px;
      margin: 0;
      color: #444;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: auto;
      padding: 0 10px 0 20px;
    }
  }
  .contentSc{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    overflow-y: auto;
    z-index: 5;
    padding: 80px 10px 10px;
    box-sizing: border-box;
  }
  .stickyCnt{
    position: absolute;
    z-index: 9;
    top: 60px; right: 0; left: 0;
    .stickyChat{
      background-color: #fff;
      padding: 8px 16px 10px;
      padding-right: 48px;
      box-shadow: 0 2px 2px rgba(0,0,0,.1);
      background-color: #fff6c9;
      position: relative;
      &:before{
        content: "";
        position: absolute;
        width: 10px; height: 10px;
        left: 16px; top: 10px;
        background-image: url(../assets/pinned.svg);
        background-size: 100% auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .6;
      }
      h4{
        margin: 0 0 4px 16px;
        font-size: 11px;
        color: #767676;
      }
      p{
        font-weight: normal;
        font-size: 15px;
        margin: 0;
        color: #444;
        line-height: 1;
        @media (max-width: 680px) {
          font-size: 14px;
        }
      }
      .unpin{
        position: absolute;
        width: 30px; height: 30px;
        background-color: rgba(0, 0, 0, .1);
        border-radius: 50%;
        right: 10px; top: 10px;
        background-image: url(../assets/close.png);
        background-size: 10px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .56;
        cursor: pointer;
      }
    }
  }
  .theChat{
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 64px;
    .loadingChat{
      position: absolute;
      top: 0; bottom: 0; left: 0; right: 0;
      background-image: url(../assets/loading.svg);
      background-size: 46px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .4;
    }
    .scHelper{
      height: 1px;
      border: none;
      background: none;
      outline: 0;
      color: #222;
    }
    .chatWrapper{
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      min-height: 100%;
      padding: 110px 0 0;
      box-sizing: border-box;
      flex-flow: column-reverse;
      .msgItem{
        padding: 5px 16px;
        padding-left: 70px;
        position: relative;
        .attLabel{
          font-size: 12px;
          color: #767676;
          margin: 8px 6px 4px;
        }
        img.profile{
          width: 240px;
          border-radius: 10px;
          display: block;
        }
        .sticker{
          width: 120px; height: 120px;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          margin-top: 10px;
          // &.lili-hi{
          //   background-image: url(../assets/lili-hi.png);
          // }
          // &.menolak{
          //   background-image: url(../assets/menolak.png);
          // }
          // &.nunu-mantul{
          //   background-image: url(../assets/nunu-mantul.png);
          // }
          // &.nunu-hmmm{
          //   background-image: url(../assets/profile-nunu.png);
          // }
          // &.lari{
          //   background-image: url(../assets/Lari.png);
          // }
          // &.sombong{
          //   background-image: url(../assets/sombong.png);
          // }
        }
        .imgPreview{
          max-width: 240px;
          border-radius: 10px;
          height: auto;
          display: block;
          margin-top: 10px;
        }
        .uploading{
          margin-top: 10px;
          width: 160px; height: 160px;
          background-color: rgba(0, 0, 0, .1);
          border-radius: 10px;
          background-image: url(../assets/loading.svg);
          background-size: 36px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        .avatar{
          position: absolute;
          left: 14px; top: 4px;
          width: 42px; height: 42px;
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
          background-color: rgba(0, 0, 0, .1);
          border-radius: 50%;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          &.finisher{
            &:before{
              content: "";
              position: absolute;
              left: -4px; top: -4px; right: -4px; bottom: -4px;
              border-radius: 50%;
              border: #ff3938 2px solid;
              z-index: 3;
            }
            &:after{
              content: "";
              position: absolute;
              top: -40px; left: 50%;
              width: 40px; height: 40px;
              margin-left: -20px;
              background-image: url(../assets/finisher-flag.png);
              background-size: 30px auto;
              background-position: 12px 8px;
              background-repeat: no-repeat;
            }
          }
          span{
            display: none;
          }
          &.noImg{
            span{
              display: block;
            }
          }
        }
        .msgContent{
          display: inline-block;
          background-color: #5351a4;
          padding: 7px 12px 4px;
          line-height: 1.3;
          font-size: 15px;
          font-weight: normal;
          border-radius: 10px;
          margin-right: auto;
          max-width: 400px;
          color: #fff;
          position: relative;
          min-height: 28px;
          box-sizing: border-box;
          margin-bottom: 8px;
          box-shadow: 2px 2px 0 rgba(0, 0, 0, .1);
          &.deleted{
            .message{
              opacity: .75;
              font-style: italic;
            }
          }
          @media (max-width: 960px) {
            font-size: 14px;
          }
          h5{
            margin: 0;
            font-size: 11px;
            color: #fff;
            @media (max-width: 960px) {
              font-size: 10px;
            }
          }
          time{
            position: absolute;
            bottom: -14px;
            color: #767676;
            font-size: 10px;
            left: 6px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 90%;
          }
          .reply{
            background-color: rgba(255, 255, 255, .1);
            margin: 2px -8px 3px;
            border-left: #fff 2px solid;
            padding: 4px 8px;
            position: relative;
            z-index: 3;
            border-radius: 3px;
            p{
              margin: 0;
              font-size: 13px;
            }
          }
          &:before{
            content: "";
            display: block;
            position: absolute;
            left: -6px; top: 0;
            border-right: #5351a4 8px solid;
            border-bottom: transparent 8px solid;
            border-top: #5351a4 20px solid;
            border-left: transparent 10px solid;
          }
          .msgMore{
            position: absolute;
            right: 0; top: 10px;
            background-color: #fff;
            box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
            border-radius: 5px;
            padding: 10px 0;
            z-index: 7;
            li{
              list-style: none;
              font-size: 15px;
              padding: 6px 16px;
              transition: all .3s ease;
              text-align: left;
              color: #444;
              white-space: nowrap;
              &.red{
                color: red;
              }
              &.divider{
                padding: 0;
                border-top: #eee 1px solid;
                margin: 5px 0;
              }
              &:hover{
                background-color: #f5f5fe;
              }
            }
          }
        }
        &.hideName{
          padding-bottom: 0;
          .msgContent{
            margin-bottom: 0;
          }
        }
        &.info{
          padding: 5px 16px;
          text-align: center;
          .msgContent{
            box-shadow: none;
            background-color: #fff7d2;
            color: #444;
            padding: 3px 8px;
            font-size: 12px;
            border-radius: 50px;
            min-height: 0;
            &:before{
              display: none;
            }
            time{
              right: 6px;
              max-width: calc(100% - 12px);
              text-align: center;
            }
          }
        }
        &.me{
          text-align: right;
          padding-left: 16px;
          padding-right: 70px;
          .avatar{
            left: auto; right: 14px;
          }
          .sticker, .uploading, .imgPreview, img.profile{
            margin-left: auto;
          }
          .msgContent{
            background-color: #fffcd8;
            color: #444;
            box-shadow: -1px 1px 2px rgba(0, 0, 0, .1);
            text-align: left;
            h5{
              color: #444;
            }
            .reply{
              background-color: rgba(0, 0, 0, .04);
              border-color: #5351a4;
            }
            &:before{
              left: auto; right: -6px;
              border-left: #fffcd8 8px solid;
              border-bottom: transparent 8px solid;
              border-top: #fffcd8 20px solid;
              border-right: transparent 10px solid;
            }
          }
        }
      }
    }
  }
  .chatFooter{
    position: absolute;
    left: 0; right: 0; bottom: 0;
    background-color: #fff;
    padding: 12px 10px 64px;
    box-sizing: border-box;
    box-shadow: 2px 2px 8px rgba(0,0,0,.2);
    z-index: 99;

    padding-bottom: 16px;
    padding-top: 8px;
    @media (max-width: 960px) {
      padding-bottom: 16px;
      padding-top: 8px;
    }
    .scrollChat{
      position: absolute;
      top: -46px; right: 16px;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 50%;
      cursor: pointer;
      transition: all .3s ease;
      box-shadow: 0 2px 4px rgba(0,0,0,.4);
      z-index: 9;
      outline: 0;
      width: 34px; height: 34px;
      background-image: url(../assets/down-arrow.png);
      background-size: 16px auto;
      background-position: 50% 10px;
      background-repeat: no-repeat;
      &:hover{
        background-color: #f5f5fe;
      }
    }
    .stickerCnt{
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      padding-top: 10px;
      .stickerItem{
        width: 60px; height: 60px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        margin: 0 5px 10px;
        cursor: pointer;
        // &.lili-hi{
        //   background-image: url(../assets/lili-hi.png);
        // }
        // &.menolak{
        //   background-image: url(../assets/menolak.png);
        // }
        // &.nunu-mantul{
        //   background-image: url(../assets/nunu-mantul.png);
        // }
        // &.nunu-hmmm{
        //   background-image: url(../assets/profile-nunu.png);
        // }
        // &.lari{
        //   background-image: url(../assets/Lari.png);
        // }
        // &.sombong{
        //   background-image: url(../assets/sombong.png);
        // }
      }
    }
    .emojiCnt{
      position: absolute;
      right: 10px; bottom: 100%;
      border-radius: 5px;
      box-shadow: 0 0 8px rgba(0, 0, 0, .2);
    }
    .attCnt{
      position: absolute;
      right: 10px; bottom: 100%;
      background-color: #fff;
      border-radius: 5px;
      width: 280px;
      padding: 10px 0;
      box-shadow: 0 0 8px rgba(0, 0, 0, .2);
      li{
        list-style: none;
        padding: 8px 30px;
        cursor: pointer;
        padding-left: 70px;
        position: relative;
        transition: all .3s ease;
        &:hover{
          background-color: #f5f5fe;
        }
        &:before{
          content: "";
          position: absolute;
          left: 20px; top: 10px;
          width: 30px; height: 30px;
          background-image: url(../assets/chat-media2.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }
        p{
          margin: 0;
          font-size: 13px;
          color: #767676;
        }
        &.profile:before{
          background-image: url(../assets/chat-profile.png);
        }
        &.finisher:before{
          background-image: url(../assets/chat-finisher.png);
        }
        &.sticker:before{
          background-image: url(../assets/lili-hi.png);
        }
      }
    }
    .replyCnt{
      margin-top: 4px;
      margin-left: 10px;
      padding-left: 12px;
      border-left: #8EC642 2px solid;
      position: relative;
      padding-right: 48px;
      .close{
        position: absolute;
        width: 30px; height: 30px;
        background-color: #ddd;
        border-radius: 50%;
        right: 10px; top: 1px;
        background-image: url(../assets/close.png);
        background-size: 10px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .56;
      }
      label{
        margin: 0 0 -2px;
        font-size: 12px;
        color: #767676;
        display: flex;
        align-items: center;
        &:before{
          width: 10px; height: 10px;
          background-image: url(../assets/reply.png);
          background-size: 10px auto;
          background-position: center;
          background-repeat: no-repeat;
          margin-top: -3px;
          opacity: .46;
          margin-right: 6px;
          content: "";
        }
      }
      p{
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
      }
    }
    .imgPreview{
      width: 46px; height: 46px;
      border-radius: 3px;
      background-position: center;
      background-size: cover;
      cursor: pointer;
      margin: 10px 0 0 10px;
      position: relative;
      &:before{
        content: "";
        position: absolute;
        width: 16px; height: 16px;
        background-color: #222;
        border-radius: 50%;
        right: -4px; top: -4px;
        background-image: url(../assets/close-white.png);
        background-size: 6px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .textField{
      background-color: #efefef;
      padding: 12px 20px 8px;
      border-radius: 22px;
      outline: 0 !important;
      max-height: 110px;
      overflow-y: auto;
      min-height: 48px;
      box-sizing: border-box;
      line-height: 1.3;
      font-weight: normal;
      border: #fff 2px solid;
      transition: all .3s ease;
      color: #444;
      margin-right: 156px;

      margin-right: 114px;
      @media (max-width: 960px) {
        margin-right: 114px;
      }
      &:focus{
        border-color: #5351a4;
        background-color: #fff;
      }
      &:empty:before {
        content: attr(placeholder);
        color: #767676;
        display: block;
        position:absolute;
      }
    }
    .sendBtn{
      width: 36px; height: 36px;
      border-radius: 50%;
      position: absolute;
      right: 12px; top: 14px;
      background-size: 20px auto;
      background-repeat: no-repeat;
      background-position: 10px 50%;
      background-image: url(../assets/send.png);
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #ddd;
      }
      &.sticker{
        background-image: url(../assets/sticker.png);
        background-position: center;
        background-size: 20px auto;
        right: 84px;
      }
      &.emoji{
        background-image: url(../assets/emoji.png);
        background-position: center;
        background-size: 19px auto;
        right: 120px;

        right: 84px;
        @media (max-width: 960px) {
          display: none;
        }
      }
      &.attachmentIcon{
        background-image: url(../assets/attachment2.png);
        background-position: center;
        background-size: 18px auto;
        right: 50px;
      }
    }
  }

}
</style>
